import { render, staticRenderFns } from "./AppAlertsCoaAlertsConfig.vue?vue&type=template&id=0e3e2b58&scoped=true&"
import script from "./AppAlertsCoaAlertsConfig.vue?vue&type=script&lang=js&"
export * from "./AppAlertsCoaAlertsConfig.vue?vue&type=script&lang=js&"
import style0 from "./AppAlertsCoaAlertsConfig.vue?vue&type=style&index=0&id=0e3e2b58&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0e3e2b58",
  null
  
)

export default component.exports